import { deleteRequest, getRequest, postRequest } from "./performanceApiClient";

export const listFeedback = async (params = {}) =>
  getRequest("/feedback", {
    params,
  });

export const getFeedbackById = async (feedbackId) =>
  getRequest(`/feedback/${feedbackId}`);

export const createFeedback = async (payload) =>
  postRequest("/feedback", payload);

export const acknowledgeFeedback = async (feedbackId) =>
  postRequest(`/feedback/${feedbackId}/acknowledge`, {});

export const deleteFeedback = async (feedbackId) =>
  deleteRequest(`/feedback/${feedbackId}`);

export default {
  listFeedback,
  getFeedbackById,
  createFeedback,
  acknowledgeFeedback,
  deleteFeedback,
};
